import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../store';
import { closeModal, openModal } from '../store/slices/modalSlice';

export const useModal = () => {
  const dispatch = useDispatch();
  const { isOpen, interestedPlan } = useSelector(
    (state: RootState) => state.modal
  );

  const openAppointmentModal = useCallback(
    (plan?: string) => {
      dispatch(openModal(plan));
    },
    [dispatch]
  );

  const closeAppointmentModal = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  return {
    isOpen,
    interestedPlan,
    openAppointmentModal,
    closeAppointmentModal,
  };
};
